import Button from 'react-bootstrap/Button'
import './buttons.scss'

function RegisterButton({ text, onClick }) {
    return (
        <Button className='register-button' onClick={onClick}>{text}</Button>
    )
}

export default RegisterButton